var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createElement, forwardRef } from "react";
import { isValidElementType } from "react-is";
import styled from "styled-components";
import Text from "../text/Text";
import omit from "lodash/omit";
import { isSpecialKey, trapEvent } from "../../utils/EventHelpers";
const LinkComponent = forwardRef(function LinkComponent(props, ref) {
    const { to, onClick } = props, rest = __rest(props, ["to", "onClick"]);
    // if there is a onClick callback we don't want to trigger the default action (opening the url)
    // unless when clicking while holding shift/ctrl/cmd, which tells the browser to open in a new tab
    const handleClick = (e) => {
        if (onClick && !isSpecialKey(e)) {
            e.preventDefault();
            onClick(e);
        }
    };
    // We want all intrinsic elements to be passed to the Link.as component
    if (props.as && isValidElementType(props.as) && typeof props.as !== "string") {
        return (React.createElement(Text, Object.assign({}, (props.variant && { variant: props.variant })), createElement(props.as, Object.assign(Object.assign({}, omit(props, ["as", "variant"])), { ref }))));
    }
    return (React.createElement(Text, Object.assign({ onClick: handleClick, onContextMenu: (e) => {
            e.stopPropagation();
        }, ref: ref }, (props.as === "a" && {
        href: to,
        rel: "noreferrer noopener",
    }), rest)));
});
export const StyledLink = styled(LinkComponent).withConfig({ displayName: "StyledLink_APC-7281-productShell", componentId: "sc-az2btl" })(({ theme, $disabled }) => (Object.assign({ color: theme.colors.apolloColorTextInteractive, textDecoration: "underline dotted", 
    /* to remove button native styles */
    background: "transparent", border: "none", padding: 0, cursor: "pointer", outline: "none", "&:hover, &:active": {
        textDecorationStyle: "solid",
    }, "&[data-focus-visible-added]": {
        textDecoration: "none",
    } }, ($disabled && {
    color: theme.colors.apolloColorTextDisabled,
    cursor: "not-allowed",
    textDecoration: "none",
}))));
const Link = forwardRef(function Link(_a, ref) {
    var { as = "a", disabled } = _a, rest = __rest(_a, ["as", "disabled"]);
    const disabledProps = disabled && {
        forwardedAs: "span",
        "aria-disabled": "true",
        role: "link",
        $disabled: true,
        onClick: trapEvent,
    };
    return React.createElement(StyledLink, Object.assign({ forwardedAs: as, ref: ref }, rest, disabledProps));
});
export default Link;
//# sourceMappingURL=Link.js.map